import { IS_SSR } from '../constants';

export const getQueryStringValue = (key: string): string | null => {
    if (IS_SSR) return null;

    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
};
